import React from "react";
import "./Home.scss";
import DeepDive from "./HomeComponets/DeepDive/DeepDive";
import KeyFeature from "./HomeComponets/Feature/KeyFeature";
import OurPartner from "./HomeComponets/OurPartner/OurPartner";
import Roadmap from "./HomeComponets/Roadmap/Roadmap";
import SuperApp from "./HomeComponets/SuperApp/SuperApp";
import Token from "./HomeComponets/Token/Token";
import Transactions from "./HomeComponets/Transactions/Transactions";
import UseCases from "./HomeComponets/UseCases/UseCases";
import WhyTriskel from "./HomeComponets/WhyTriskel/WhyTriskel";
import DownloadSuperApp from "./HomeComponets/Download/DownloadSuperApp";
import OurCertificate from "./HomeComponets/OurCertificate/OurCertificate";
import FrequentlyAsked from "./HomeComponets/FrequentlyAsked/FrequentlyAsked";

import { Link } from "react-router-dom";
import { GreenApp, GreenPlay } from "../../Common/SvgIcons/SvgIcons";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

import TableSvg from "../../assets/table.svg";

const Table = (props) => (
  <svg
    viewBox="0 0 950 570"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <g id="Group">
      <g id="Layer 1">
        <g id="bg 0" filter="url(#filter0_d_2_4)">
          <path
            d="M8 80.83H200.1V490.4H8C5.87827 490.4 3.84344 489.557 2.34315 488.057C0.842855 486.557 0 484.522 0 482.4V88.83C0 86.7083 0.842855 84.6734 2.34315 83.1731C3.84344 81.6729 5.87827 80.83 8 80.83Z"
            fill="#252525"
          />
        </g>
        <g id="alternating bg 0">
          <path
            id="alternating bg 0_2"
            d="M200 138.47H0V188.34H200V138.47Z"
            fill="#1F1F1F"
          />
          <path
            id="alternating bg 0_3"
            d="M200 238.87H0V289H200V238.87Z"
            fill="#1F1F1F"
          />
          <path
            id="alternating bg 0_4"
            d="M200 339.68H0V389.9H200V339.68Z"
            fill="#1F1F1F"
          />
          <path
            id="alternating bg 0_5"
            d="M0 440.28H200V489.87H8C5.87827 489.87 3.84344 489.027 2.34315 487.527C0.842855 486.027 0 483.992 0 481.87V440.28Z"
            fill="#1F1F1F"
          />
        </g>
        <g id="Features Text">
          <text
            id="Features"
            fill="white"
            xmlSpace="preserve"
            style={{
              whiteSpace: "pre",
            }}
            fontFamily="Poppins"
            fontSize={16}
            fontWeight="bold"
            letterSpacing="0em"
          >
            <tspan x={64} y={114.6}>
              {"Features"}
            </tspan>
          </text>
          <text
            id="Wallet Services"
            fill="white"
            xmlSpace="preserve"
            style={{
              whiteSpace: "pre",
            }}
            fontFamily="Poppins"
            fontSize={14}
            fontWeight={300}
            letterSpacing="0em"
          >
            <tspan x={50.08} y={168.69}>
              {"Wallet Services"}
            </tspan>
          </text>
          <text
            id="Crypto Debit Card"
            fill="white"
            xmlSpace="preserve"
            style={{
              whiteSpace: "pre",
            }}
            fontFamily="Poppins"
            fontSize={14}
            fontWeight={300}
            letterSpacing="0em"
          >
            <tspan x={30} y={219.69}>
              {"Crypto Debit Card"}
            </tspan>
          </text>
          <text
            id="IBAN Facility"
            fill="white"
            xmlSpace="preserve"
            style={{
              whiteSpace: "pre",
            }}
            fontFamily="Poppins"
            fontSize={14}
            fontWeight={300}
            letterSpacing="0em"
          >
            <tspan x={48} y={269.69}>
              {"IBAN Facility"}
            </tspan>
          </text>
          <text
            id="STO Platform"
            fill="white"
            xmlSpace="preserve"
            style={{
              whiteSpace: "pre",
            }}
            fontFamily="Poppins"
            fontSize={14}
            fontWeight={300}
            letterSpacing="0em"
          >
            <tspan x={57.7} y={319.69}>
              {"STO Platform"}
            </tspan>
          </text>
          <text
            id="Cross-Chain Swaps"
            fill="white"
            xmlSpace="preserve"
            style={{
              whiteSpace: "pre",
            }}
            fontFamily="Poppins"
            fontSize={14}
            fontWeight={300}
            letterSpacing="0em"
          >
            <tspan x={33.57} y={370.69}>
              {"Cross-Chain Swaps"}
            </tspan>
          </text>
          <text
            id="On/Off-Ramp Integration"
            fill="white"
            xmlSpace="preserve"
            style={{
              whiteSpace: "pre",
            }}
            fontFamily="Poppins"
            fontSize={14}
            fontWeight={300}
            letterSpacing="0em"
          >
            <tspan x={14.75} y={420.69}>
              {"On/Off-Ramp Integration"}
            </tspan>
          </text>
          <text
            id="Multi-Language Support"
            fill="white"
            xmlSpace="preserve"
            style={{
              whiteSpace: "pre",
            }}
            fontFamily="Poppins"
            fontSize={14}
            fontWeight={300}
            letterSpacing="0em"
          >
            <tspan x={17.96} y={470.69}>
              {"Multi-Language Support"}
            </tspan>
          </text>
        </g>
        <g id="bg 4">
          <g id="Group_2">
            <g id="Vector" filter="url(#filter1_d_2_4)">
              <path
                d="M942 490.87H814.89V80.93H942C944.122 80.93 946.157 81.7728 947.657 83.2731C949.157 84.7734 950 86.8083 950 88.93V482.87C950 484.992 949.157 487.027 947.657 488.527C946.157 490.027 944.122 490.87 942 490.87Z"
                fill="#252525"
              />
            </g>
          </g>
          <g id="Meta Mask text">
            <text
              id="Yami Wallet"
              fill="white"
              xmlSpace="preserve"
              style={{
                whiteSpace: "pre",
              }}
              fontFamily="Poppins"
              fontSize={14.4817}
              fontWeight="bold"
              letterSpacing="0em"
            >
              <tspan x={835.73} y={116.359}>
                {"Yami Wallet"}
              </tspan>
            </text>
          </g>
          <path
            id="Vector_2"
            d="M872.58 164.87L875.25 162.37L879.51 166.62L889.64 157.87L892.31 160.62L879.24 171.87L872.58 164.87Z"
            fill="#6D6D6D"
          />
          <path
            id="Vector_3"
            d="M872.58 215.87L875.25 213.37L879.51 217.62L889.64 208.87L892.31 211.62L879.24 222.87L872.58 215.87Z"
            fill="#6D6D6D"
          />
          <path
            id="Vector_4"
            d="M872.58 265.87L875.25 263.37L879.51 267.62L889.64 258.87L892.31 261.62L879.24 272.87L872.58 265.87Z"
            fill="#6D6D6D"
          />
          <path
            id="Vector_5"
            d="M872.58 415.87L875.25 413.37L879.51 417.62L889.64 408.87L892.31 411.62L879.24 422.87L872.58 415.87Z"
            fill="#6D6D6D"
          />
          <path
            id="Vector_6"
            d="M872.58 363.87L875.25 361.37L879.51 365.62L889.64 356.87L892.31 359.62L879.24 370.87L872.58 363.87Z"
            fill="#6D6D6D"
          />
          <path
            id="Vector_7"
            d="M872.58 464.87L875.25 462.37L879.51 466.62L889.64 457.87L892.31 460.62L879.24 471.87L872.58 464.87Z"
            fill="#6D6D6D"
          />
          <g id="Group_3">
            <path
              id="Vector_8"
              d="M875.78 320.62L889.11 308.12"
              stroke="#CFFE25"
              strokeWidth={3.6}
              strokeMiterlimit={10}
            />
            <path
              id="Vector_9"
              d="M889.11 320.62L875.78 308.12"
              stroke="#CFFE25"
              strokeWidth={3.6}
              strokeMiterlimit={10}
            />
          </g>
        </g>
        <g id="bg 3">
          <g id="Group_4">
            <g id="Vector_10" filter="url(#filter2_d_2_4)">
              <path
                d="M814.88 80.93H679.47V490.87H814.88V80.93Z"
                fill="#252525"
              />
            </g>
          </g>
          <g id="Meta Mask text_2">
            <text
              id="SORA Card"
              fill="white"
              xmlSpace="preserve"
              style={{
                whiteSpace: "pre",
              }}
              fontFamily="Poppins"
              fontSize={14.4403}
              fontWeight="bold"
              letterSpacing="0em"
            >
              <tspan x={705.6} y={116.304}>
                {"SORA Card"}
              </tspan>
            </text>
          </g>
          <path
            id="Vector_11"
            d="M737.16 164.87L739.83 162.37L744.1 166.62L754.23 157.87L756.89 160.62L743.83 171.87L737.16 164.87Z"
            fill="#6D6D6D"
          />
          <path
            id="Vector_12"
            d="M737.16 215.87L739.83 213.37L744.1 217.62L754.23 208.87L756.89 211.62L743.83 222.87L737.16 215.87Z"
            fill="#6D6D6D"
          />
          <path
            id="Vector_13"
            d="M737.16 265.87L739.83 263.37L744.1 267.62L754.23 258.87L756.89 261.62L743.83 272.87L737.16 265.87Z"
            fill="#6D6D6D"
          />
          <path
            id="Vector_14"
            d="M737.16 415.87L739.83 413.37L744.1 417.62L754.23 408.87L756.89 411.62L743.83 422.87L737.16 415.87Z"
            fill="#6D6D6D"
          />
          <path
            id="Vector_15"
            d="M737.16 363.87L739.83 361.37L744.1 365.62L754.23 356.87L756.89 359.62L743.83 370.87L737.16 363.87Z"
            fill="#6D6D6D"
          />
          <path
            id="Vector_16"
            d="M737.16 464.87L739.83 462.37L744.1 466.62L754.23 457.87L756.89 460.62L743.83 471.87L737.16 464.87Z"
            fill="#6D6D6D"
          />
          <g id="Group_5">
            <path
              id="Vector_17"
              d="M740.36 320.62L753.69 308.12"
              stroke="#CFFE25"
              strokeWidth={3.6}
              strokeMiterlimit={10}
            />
            <path
              id="Vector_18"
              d="M753.69 320.62L740.36 308.12"
              stroke="#CFFE25"
              strokeWidth={3.6}
              strokeMiterlimit={10}
            />
          </g>
        </g>
        <g id="bg 2">
          <g id="Group_6">
            <g id="Vector_19" filter="url(#filter3_d_2_4)">
              <path
                d="M679.48 80.93H543.76V490.87H679.48V80.93Z"
                fill="#252525"
              />
            </g>
          </g>
          <g id="Meta Mask text_3">
            <text
              id="Trust Wallet"
              fill="white"
              xmlSpace="preserve"
              style={{
                whiteSpace: "pre",
              }}
              fontFamily="Poppins"
              fontSize={14.4817}
              fontWeight="bold"
              letterSpacing="0em"
            >
              <tspan x={565.25} y={116.359}>
                {"Trust Wallet"}
              </tspan>
            </text>
          </g>
          <path
            id="Vector_20"
            d="M601.75 164.87L604.42 162.37L608.68 166.62L618.81 157.87L621.48 160.62L608.41 171.87L601.75 164.87Z"
            fill="#6D6D6D"
          />
          <path
            id="Vector_21"
            d="M601.75 464.87L604.42 462.37L608.68 466.62L618.81 457.87L621.48 460.62L608.41 471.87L601.75 464.87Z"
            fill="#6D6D6D"
          />
          <path
            id="Vector_22"
            d="M601.75 415.87L604.42 413.37L608.68 417.62L618.81 408.87L621.48 411.62L608.41 422.87L601.75 415.87Z"
            fill="#6D6D6D"
          />
          <g id="Group_7">
            <path
              id="Vector_23"
              d="M604.95 271.62L618.28 259.12"
              stroke="#CFFE25"
              strokeWidth={3.6}
              strokeMiterlimit={10}
            />
            <path
              id="Vector_24"
              d="M618.28 271.62L604.95 259.12"
              stroke="#CFFE25"
              strokeWidth={3.6}
              strokeMiterlimit={10}
            />
          </g>
          <g id="Group_8">
            <path
              id="Vector_25"
              d="M604.95 221.62L618.28 209.12"
              stroke="#CFFE25"
              strokeWidth={3.6}
              strokeMiterlimit={10}
            />
            <path
              id="Vector_26"
              d="M618.28 221.62L604.95 209.12"
              stroke="#CFFE25"
              strokeWidth={3.6}
              strokeMiterlimit={10}
            />
          </g>
          <g id="Group_9">
            <path
              id="Vector_27"
              d="M604.95 370.62L618.28 358.12"
              stroke="#CFFE25"
              strokeWidth={3.6}
              strokeMiterlimit={10}
            />
            <path
              id="Vector_28"
              d="M618.28 370.62L604.95 358.12"
              stroke="#CFFE25"
              strokeWidth={3.6}
              strokeMiterlimit={10}
            />
          </g>
          <g id="Group_10">
            <path
              id="Vector_29"
              d="M604.95 320.62L618.28 308.12"
              stroke="#CFFE25"
              strokeWidth={3.6}
              strokeMiterlimit={10}
            />
            <path
              id="Vector_30"
              d="M618.28 320.62L604.95 308.12"
              stroke="#CFFE25"
              strokeWidth={3.6}
              strokeMiterlimit={10}
            />
          </g>
        </g>
        <g id="bg 1" filter="url(#filter4_d_2_4)">
          <g id="Vector_31" filter="url(#filter5_d_2_4)">
            <path
              d="M543.75 80.93H408.64V490.87H543.75V80.93Z"
              fill="#252525"
            />
          </g>
        </g>
        <g id="grid lines">
          <path
            id="Vector_32"
            d="M13.6 138.47L128.95 138.23L244.3 138.14L475 137.97L705.7 138.14L821.05 138.23L936.4 138.47L821.05 138.72L705.7 138.81L475 138.97L244.3 138.81L128.95 138.72L13.6 138.47Z"
            fill="#4C4C4C"
          />
          <path
            id="Vector_33"
            d="M13.6 188.35L128.95 188.1L244.3 188.01L475 187.85L705.7 188.01L821.05 188.1L936.4 188.35L821.05 188.59L705.7 188.68L475 188.85L244.3 188.68L128.95 188.59L13.6 188.35Z"
            fill="#4C4C4C"
          />
          <path
            id="Vector_34"
            d="M13.6 238.73L128.95 238.49L244.3 238.4L475 238.24L705.7 238.4L821.05 238.49L936.4 238.73L821.05 238.98L705.7 239.07L475 239.23L244.3 239.06L128.95 238.98L13.6 238.73Z"
            fill="#4C4C4C"
          />
          <path
            id="Vector_35"
            d="M13.6 289.12L128.95 288.88L244.3 288.79L475 288.62L705.7 288.79L821.05 288.88L936.4 289.12L821.05 289.37L705.7 289.45L475 289.62L244.3 289.45L128.95 289.36L13.6 289.12Z"
            fill="#4C4C4C"
          />
          <path
            id="Vector_36"
            d="M13.6 339.51L128.95 339.26L244.3 339.18L475 339.01L705.7 339.18L821.05 339.26L936.4 339.51L821.05 339.75L705.7 339.84L475 340.01L244.3 339.84L128.95 339.75L13.6 339.51Z"
            fill="#4C4C4C"
          />
          <path
            id="Vector_37"
            d="M13.6 389.9L128.95 389.65L244.3 389.56L475 389.4L705.7 389.56L821.05 389.65L936.4 389.9L821.05 390.14L705.7 390.23L475 390.39L244.3 390.23L128.95 390.14L13.6 389.9Z"
            fill="#4C4C4C"
          />
          <path
            id="Vector_38"
            d="M13.6 440.28L128.95 440.04L244.3 439.95L475 439.78L705.7 439.95L821.05 440.04L936.4 440.28L821.05 440.53L705.7 440.62L475 440.78L244.3 440.62L128.95 440.53L13.6 440.28Z"
            fill="#4C4C4C"
          />
        </g>
        <g id="triskel bg">
          <rect
            id="Rectangle"
            x={151}
            width={306}
            height={570}
            fill="url(#pattern0_2_4)"
          />
          <path
            id="Vector_39"
            d="M400.72 48.87H207.94C203.494 48.87 199.89 52.4741 199.89 56.92V513.08C199.89 517.526 203.494 521.13 207.94 521.13H400.72C405.166 521.13 408.77 517.526 408.77 513.08V56.92C408.77 52.4741 405.166 48.87 400.72 48.87Z"
            fill="#CFFE25"
          />
        </g>
        <g id="triskel grid Lines">
          <path
            id="Vector_40"
            d="M200 138.47H409"
            stroke="#C9E13C"
            strokeMiterlimit={10}
          />
          <path
            id="Vector_41"
            d="M200 188.35H409"
            stroke="#C9E13C"
            strokeMiterlimit={10}
          />
          <path
            id="Vector_42"
            d="M200 238.73H409"
            stroke="#C9E13C"
            strokeMiterlimit={10}
          />
          <path
            id="Vector_43"
            d="M200 289.12H409"
            stroke="#C9E13C"
            strokeMiterlimit={10}
          />
          <path
            id="Vector_44"
            d="M200 339.51H409"
            stroke="#C9E13C"
            strokeMiterlimit={10}
          />
          <path
            id="Vector_45"
            d="M200 389.9H409"
            stroke="#C9E13C"
            strokeMiterlimit={10}
          />
          <path
            id="Vector_46"
            d="M200 440.28H409"
            stroke="#C9E13C"
            strokeMiterlimit={10}
          />
        </g>
        <g id="Meta Mask text_4">
          <text
            id="Meta Mask"
            fill="white"
            xmlSpace="preserve"
            style={{
              whiteSpace: "pre",
            }}
            fontFamily="Poppins"
            fontSize={14}
            fontWeight="bold"
            letterSpacing="0em"
          >
            <tspan x={438.77} y={115.69}>
              {"Meta Mask"}
            </tspan>
          </text>
        </g>
        <g id="Triskel">
          <path
            id="Vector_47"
            d="M283.36 102.87C282.777 102.682 282.206 102.459 281.65 102.2C281.201 101.949 280.808 101.608 280.497 101.199C280.185 100.789 279.962 100.32 279.84 99.82C279.75 99.48 279.68 99.13 279.58 98.74C280.28 98.67 280.91 98.59 281.58 98.54C282.25 98.49 282.15 98.54 282.31 99.05C282.449 99.5556 282.746 100.003 283.159 100.327C283.571 100.651 284.076 100.834 284.6 100.85C285.34 100.954 286.094 100.817 286.75 100.46C286.962 100.343 287.143 100.179 287.278 99.9787C287.414 99.7788 287.5 99.5497 287.53 99.31C287.6 98.58 287.18 98.09 286.3 97.85C285.21 97.55 284.11 97.29 283.02 96.97C282.111 96.7453 281.304 96.2203 280.73 95.48C280.437 95.0962 280.236 94.6494 280.145 94.175C280.053 93.7005 280.074 93.2113 280.203 92.746C280.333 92.2806 280.57 91.8517 280.893 91.4932C281.217 91.1347 281.62 90.8563 282.07 90.68C283.007 90.2584 284.027 90.0538 285.053 90.0815C286.08 90.1092 287.087 90.3685 288 90.84C288.516 91.102 288.951 91.4988 289.259 91.9883C289.567 92.4778 289.737 93.0417 289.75 93.62C289.754 93.7033 289.754 93.7867 289.75 93.87C288.96 93.87 288.18 93.96 287.4 93.98C287.31 93.98 287.17 93.82 287.14 93.71C287.085 93.4114 286.955 93.132 286.76 92.899C286.566 92.6659 286.314 92.4872 286.03 92.38C285.116 92.0666 284.115 92.1204 283.24 92.53C283.064 92.6023 282.911 92.7235 282.802 92.8795C282.692 93.0354 282.629 93.2195 282.62 93.41C282.611 93.6083 282.667 93.804 282.779 93.968C282.891 94.132 283.052 94.2555 283.24 94.32C283.895 94.5708 284.563 94.7878 285.24 94.97C286.332 95.1813 287.393 95.5273 288.4 96C289.1 96.393 289.641 97.0163 289.933 97.7639C290.225 98.5114 290.249 99.337 290 100.1C289.805 100.794 289.411 101.417 288.868 101.891C288.324 102.365 287.654 102.671 286.94 102.77L286.63 102.87H283.36Z"
            fill="black"
          />
          <path
            id="Vector_48"
            d="M269.38 97.31C270.88 98.09 271.62 99.44 272.47 100.69C272.86 101.27 273.23 101.87 273.61 102.45C273.666 102.547 273.716 102.647 273.76 102.75H273.18C272.49 102.75 271.79 102.75 271.1 102.75C270.962 102.757 270.825 102.726 270.705 102.658C270.585 102.591 270.486 102.491 270.42 102.37C269.6 101.19 268.77 100.02 267.94 98.85C267.669 98.3293 267.212 97.9296 266.66 97.73C266.099 97.6329 265.53 97.5861 264.96 97.59C264.96 97.59 264.8 97.8 264.8 97.91C264.8 99.32 264.8 100.72 264.8 102.13C264.8 102.82 264.87 102.74 264.19 102.74H262.47C262.28 102.74 262.2 102.68 262.2 102.47V90.47C262.197 90.4267 262.197 90.3833 262.2 90.34C262.28 90.3352 262.36 90.3352 262.44 90.34C264.44 90.34 266.51 90.34 268.54 90.34C269.111 90.3566 269.68 90.4236 270.24 90.54C270.788 90.6292 271.298 90.8748 271.71 91.2474C272.122 91.62 272.417 92.1036 272.56 92.64C272.783 93.2349 272.832 93.8811 272.701 94.5028C272.57 95.1245 272.264 95.6959 271.82 96.15C271.271 96.679 270.573 97.0278 269.82 97.15C269.7 97.15 269.58 97.22 269.37 97.27L269.38 97.31ZM266.82 92.39H265.1C264.91 92.39 264.79 92.39 264.79 92.67V95.28C264.79 95.47 264.86 95.56 265.07 95.56C266.22 95.56 267.38 95.56 268.53 95.5C268.725 95.5122 268.92 95.485 269.103 95.4201C269.287 95.3552 269.456 95.2539 269.6 95.1223C269.743 94.9907 269.859 94.8314 269.94 94.654C270.021 94.4767 270.065 94.2848 270.07 94.09C270.102 93.9133 270.098 93.7321 270.059 93.5568C270.02 93.3816 269.947 93.2157 269.844 93.0688C269.741 92.9219 269.61 92.7969 269.458 92.701C269.306 92.6051 269.137 92.5402 268.96 92.51C268.26 92.4 267.54 92.4 266.82 92.35V92.39Z"
            fill="black"
          />
          <path
            id="Vector_49"
            d="M304 102.72H303.74C302.81 102.72 301.89 102.72 300.97 102.72C300.893 102.712 300.819 102.689 300.752 102.651C300.685 102.613 300.626 102.562 300.58 102.5C299.49 100.75 298.42 99 297.34 97.24C297.29 97.15 297.22 97.06 297.13 96.92L295.91 98.09C295.83 98.1959 295.74 98.2931 295.64 98.38C295.402 98.5359 295.214 98.7581 295.1 99.0193C294.986 99.2805 294.952 99.5693 295 99.85C295.05 100.68 295 101.52 295 102.35C295 102.65 294.91 102.74 294.61 102.74C293.99 102.74 293.36 102.74 292.73 102.74C292.49 102.74 292.38 102.74 292.38 102.43C292.38 98.5 292.38 94.58 292.38 90.65C292.38 90.39 292.47 90.33 292.72 90.33C293.387 90.33 294.027 90.33 294.64 90.33C294.92 90.33 295 90.42 295 90.69C295 92.23 295 93.77 295 95.31V95.8C295.2 95.62 295.32 95.52 295.43 95.41C296.95 93.8167 298.467 92.2233 299.98 90.63C300.066 90.5296 300.174 90.4503 300.295 90.3983C300.416 90.3463 300.548 90.3229 300.68 90.33C301.68 90.33 302.68 90.33 303.73 90.33C303.58 90.5 303.48 90.63 303.37 90.74C301.963 92.1467 300.547 93.55 299.12 94.95C299.087 94.9772 299.06 95.0115 299.041 95.0504C299.023 95.0893 299.013 95.1319 299.013 95.175C299.013 95.2181 299.023 95.2607 299.041 95.2996C299.06 95.3385 299.087 95.3728 299.12 95.4C300.71 97.72 302.29 100.06 303.86 102.4C303.923 102.5 303.98 102.603 304.03 102.71L304 102.72Z"
            fill="black"
          />
          <path
            id="Vector_50"
            d="M305.38 96.53V90.78C305.38 90.35 305.38 90.35 305.83 90.35H314.56C314.87 90.35 315 90.42 314.98 90.75C314.955 91.1963 314.955 91.6437 314.98 92.09C314.98 92.37 314.88 92.45 314.61 92.45H308.44C308.378 92.4418 308.314 92.448 308.255 92.4683C308.195 92.4885 308.141 92.5221 308.097 92.5666C308.052 92.6111 308.018 92.6652 307.998 92.7247C307.978 92.7843 307.972 92.8477 307.98 92.91C307.98 93.53 307.98 94.16 307.98 94.78C307.98 95.11 308.06 95.22 308.41 95.22C310.28 95.22 312.16 95.22 314.03 95.22C314.34 95.22 314.5 95.37 314.5 95.67C314.5 95.97 314.5 96.48 314.5 96.87C314.5 97.26 314.41 97.32 314.07 97.31C312.2 97.31 310.34 97.31 308.48 97.31C308.14 97.31 307.98 97.47 307.98 97.8C307.98 98.63 307.98 99.47 307.98 100.31C307.98 100.61 308.06 100.7 308.37 100.7H314.81C315.13 100.7 315.25 100.78 315.23 101.11C315.205 101.543 315.205 101.977 315.23 102.41C315.23 102.7 315.15 102.8 314.85 102.79C313.35 102.79 311.85 102.79 310.37 102.79C308.89 102.79 307.31 102.79 305.78 102.79C305.47 102.79 305.39 102.68 305.39 102.38C305.39 100.44 305.39 98.5 305.39 96.56L305.38 96.53Z"
            fill="black"
          />
          <path
            id="Vector_51"
            d="M250.2 90.37H260.46C260.46 91.01 260.46 91.63 260.46 92.25C260.46 92.31 260.26 92.42 260.15 92.43H257.15C257.087 92.4196 257.023 92.4243 256.962 92.4438C256.902 92.4632 256.847 92.4968 256.802 92.5418C256.757 92.5868 256.723 92.6418 256.704 92.7024C256.684 92.7629 256.68 92.8273 256.69 92.89C256.69 96.03 256.69 99.18 256.69 102.32C256.69 102.65 256.61 102.77 256.26 102.76C255.66 102.76 255.05 102.76 254.44 102.76C254.15 102.76 254.06 102.68 254.06 102.38C254.06 99.21 254.06 96.05 254.06 92.88V92.46H253.63H250.56C250.3 92.46 250.21 92.38 250.22 92.12C250.21 91.53 250.2 91 250.2 90.37Z"
            fill="black"
          />
          <path
            id="Vector_52"
            d="M320.15 100.66H326.61V101.5C326.61 101.8 326.61 102.1 326.61 102.4C326.61 102.7 326.5 102.76 326.24 102.76H320.78C319.78 102.76 318.78 102.76 317.85 102.76C317.61 102.76 317.51 102.76 317.51 102.45C317.51 98.55 317.51 94.6467 317.51 90.74C317.51 90.67 317.51 90.59 317.51 90.48H317.8C318.44 90.48 319.08 90.48 319.72 90.48C320.01 90.48 320.09 90.57 320.09 90.85C320.09 92.37 320.09 93.85 320.09 95.43V100.21C320.09 100.37 320.09 100.52 320.09 100.7L320.15 100.66Z"
            fill="black"
          />
          <path
            id="Vector_53"
            d="M275.17 90.35H277.58C277.64 90.35 277.72 90.45 277.75 90.53C277.765 90.6059 277.765 90.6841 277.75 90.76V102.3C277.759 102.361 277.753 102.423 277.733 102.481C277.714 102.539 277.68 102.591 277.637 102.634C277.593 102.677 277.539 102.709 277.481 102.727C277.422 102.746 277.36 102.75 277.3 102.74C276.69 102.74 276.07 102.74 275.45 102.74C275.23 102.74 275.13 102.74 275.13 102.44C275.13 98.48 275.13 94.52 275.13 90.56C275.13 90.56 275.13 90.45 275.13 90.34L275.17 90.35Z"
            fill="black"
          />
        </g>
        <text
          id="Wallet"
          fill="black"
          xmlSpace="preserve"
          style={{
            whiteSpace: "pre",
          }}
          fontFamily="Poppins"
          fontSize={17}
          fontWeight="bold"
          letterSpacing="0em"
        >
          <tspan x={330} y={102.95}>
            {"Wallet"}
          </tspan>
        </text>
        <path
          id="Vector_54"
          d="M297.75 164.87L300.25 162.37L304.25 166.62L313.75 157.87L316.25 160.62L304 171.87L297.75 164.87Z"
          fill="#252525"
        />
        <path
          id="Vector_55"
          d="M467.75 164.87L470.25 162.37L474.25 166.62L483.75 157.87L486.25 160.62L474 171.87L467.75 164.87Z"
          fill="#6D6D6D"
        />
        <path
          id="Vector_56"
          d="M297.75 214L300.25 211.5L304.25 215.75L313.75 207L316.25 209.75L304 221L297.75 214Z"
          fill="#252525"
        />
        <path
          id="Vector_57"
          d="M297.75 262.87L300.25 260.37L304.25 264.62L313.75 255.87L316.25 258.62L304 269.87L297.75 262.87Z"
          fill="#252525"
        />
        <path
          id="Vector_58"
          d="M297.75 313L300.25 310.5L304.25 314.75L313.75 306L316.25 308.75L304 320L297.75 313Z"
          fill="#252525"
        />
        <path
          id="Vector_59"
          d="M297.75 363.87L300.25 361.37L304.25 365.62L313.75 356.87L316.25 359.62L304 370.87L297.75 363.87Z"
          fill="#252525"
        />
        <path
          id="Vector_60"
          d="M297.75 415.87L300.25 413.37L304.25 417.62L313.75 408.87L316.25 411.62L304 422.87L297.75 415.87Z"
          fill="#252525"
        />
        <path
          id="Vector_61"
          d="M297.75 461.87L300.25 459.37L304.25 463.62L313.75 454.87L316.25 457.62L304 468.87L297.75 461.87Z"
          fill="#252525"
        />
        <path
          id="Vector_62"
          d="M467.75 464.87L470.25 462.37L474.25 466.62L483.75 457.87L486.25 460.62L474 471.87L467.75 464.87Z"
          fill="#6D6D6D"
        />
        <path
          id="Vector_63"
          d="M467.75 414.25L470.25 411.75L474.25 416L483.75 407.25L486.25 410L474 421.25L467.75 414.25Z"
          fill="#6D6D6D"
        />
        <g id="Group_11">
          <path
            id="Vector_64"
            d="M470.75 271.62L483.25 259.12"
            stroke="#CFFE25"
            strokeWidth={3.6}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_65"
            d="M483.25 271.62L470.75 259.12"
            stroke="#CFFE25"
            strokeWidth={3.6}
            strokeMiterlimit={10}
          />
        </g>
        <g id="Group_12">
          <path
            id="Vector_66"
            d="M470.75 221.62L483.25 209.12"
            stroke="#CFFE25"
            strokeWidth={3.6}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_67"
            d="M483.25 221.62L470.75 209.12"
            stroke="#CFFE25"
            strokeWidth={3.6}
            strokeMiterlimit={10}
          />
        </g>
        <g id="Group_13">
          <path
            id="Vector_68"
            d="M470.75 370.62L483.25 358.12"
            stroke="#CFFE25"
            strokeWidth={3.6}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_69"
            d="M483.25 370.62L470.75 358.12"
            stroke="#CFFE25"
            strokeWidth={3.6}
            strokeMiterlimit={10}
          />
        </g>
        <g id="Group_14">
          <path
            id="Vector_70"
            d="M470.75 320.62L483.25 308.12"
            stroke="#CFFE25"
            strokeWidth={3.6}
            strokeMiterlimit={10}
          />
          <path
            id="Vector_71"
            d="M483.25 320.62L470.75 308.12"
            stroke="#CFFE25"
            strokeWidth={3.6}
            strokeMiterlimit={10}
          />
        </g>
        <path
          id="Vector_72"
          d="M220 101.574C220.015 101.522 220.039 101.472 220.043 101.419C220.072 101.044 220.125 100.672 220.221 100.309C220.341 99.8521 220.483 99.4005 220.702 98.9845C220.872 98.66 221.038 98.3292 221.274 98.0453C221.404 97.8889 221.517 97.7173 221.652 97.5654C221.861 97.3297 222.084 97.1103 222.326 96.9079C222.707 96.5877 223.118 96.3153 223.561 96.1018C223.825 95.9743 224.103 95.8728 224.381 95.7816C225.429 95.4385 226.488 95.4352 227.547 95.7144C227.988 95.8307 228.42 95.9884 228.817 96.2266C229.08 96.3848 229.342 96.5508 229.581 96.7445C229.849 96.9614 230.098 97.2028 230.327 97.4695C230.575 97.7585 230.784 98.074 230.976 98.4014C231.145 98.6898 231.263 99.0055 231.379 99.3224C231.653 100.076 231.728 100.854 231.663 101.65C231.633 102.009 231.575 102.364 231.461 102.704C231.342 103.062 231.216 103.421 231.023 103.745C230.869 104.003 230.704 104.256 230.521 104.491C230.321 104.746 230.092 104.973 229.846 105.184C229.613 105.386 229.36 105.551 229.096 105.701C228.338 106.134 227.52 106.29 226.661 106.25C226.129 106.225 225.61 106.129 225.118 105.913C224.825 105.784 224.55 105.622 224.294 105.425C224.094 105.271 223.918 105.09 223.746 104.905C223.477 104.614 223.262 104.281 223.07 103.933C222.905 103.634 222.802 103.311 222.706 102.982C222.59 102.579 222.565 102.171 222.582 101.755C222.603 101.254 222.747 100.787 222.935 100.33C223.068 100.008 223.262 99.7266 223.475 99.4606C223.77 99.0931 224.13 98.8067 224.537 98.5834C225.459 98.0781 226.403 98.0455 227.36 98.4554C227.673 98.5893 227.959 98.7824 228.204 99.0256C228.55 99.3675 228.809 99.7686 228.971 100.242C229.153 100.774 229.177 101.308 229.031 101.847C228.941 102.177 228.798 102.487 228.582 102.752C228.284 103.118 227.921 103.381 227.475 103.523C227.202 103.61 226.928 103.66 226.646 103.615C226.276 103.557 225.945 103.407 225.665 103.143C225.352 102.85 225.168 102.489 225.145 102.05C225.126 101.671 225.223 101.326 225.495 101.06C225.705 100.855 225.959 100.753 226.256 100.806C226.385 100.828 226.5 100.884 226.591 100.975C226.649 101.034 226.692 101.119 226.718 101.2C226.762 101.338 226.697 101.462 226.568 101.52C226.52 101.541 226.468 101.555 226.42 101.578C226.219 101.675 226.172 101.874 226.306 102.058C226.517 102.348 226.876 102.445 227.215 102.29C227.615 102.107 227.846 101.774 227.876 101.331C227.925 100.63 227.615 100.108 227.052 99.7342C226.825 99.5831 226.581 99.493 226.312 99.4673C225.99 99.4364 225.676 99.4847 225.379 99.6088C225.084 99.732 224.806 99.8966 224.579 100.131C224.22 100.502 223.971 100.941 223.879 101.467C223.798 101.921 223.836 102.367 223.961 102.806C224.073 103.201 224.262 103.556 224.521 103.863C225.108 104.559 225.853 104.926 226.743 104.971C227.208 104.994 227.661 104.922 228.095 104.75C228.349 104.649 228.593 104.521 228.821 104.364C229.039 104.213 229.232 104.033 229.411 103.837C230.004 103.193 230.324 102.421 230.406 101.539C230.475 100.79 230.352 100.074 230.059 99.3897C229.941 99.1157 229.792 98.8586 229.617 98.6188C229.329 98.2258 228.991 97.8888 228.598 97.6108C228.019 97.2018 227.379 96.9647 226.689 96.8615C226.356 96.8118 226.024 96.7943 225.691 96.8341C225.201 96.8928 224.722 97.0037 224.264 97.2019C223.916 97.3522 223.601 97.5566 223.291 97.7753C223.048 97.9475 222.831 98.1546 222.632 98.3751C222.281 98.7642 221.991 99.1995 221.768 99.6854C221.615 100.019 221.494 100.361 221.414 100.719C221.208 101.638 221.232 102.555 221.471 103.464C221.529 103.687 221.595 103.912 221.687 104.122C221.846 104.486 222.005 104.853 222.248 105.17C222.379 105.341 222.497 105.525 222.637 105.688C222.829 105.911 223.04 106.114 223.261 106.308C223.641 106.641 224.063 106.898 224.51 107.114C224.849 107.279 225.21 107.383 225.572 107.482C226.15 107.639 226.736 107.668 227.327 107.624C227.574 107.606 227.823 107.578 228.063 107.52C228.574 107.396 229.078 107.245 229.55 107C229.756 106.892 229.957 106.77 230.154 106.645C230.492 106.432 230.801 106.174 231.085 105.891C231.36 105.617 231.617 105.324 231.837 104.996C232.035 104.701 232.203 104.39 232.365 104.073C232.627 103.554 232.775 103.001 232.884 102.432C233.014 101.76 233.029 101.082 232.968 100.402C232.904 99.686 232.737 98.9946 232.451 98.3403C232.232 97.8401 231.962 97.368 231.622 96.9436C231.477 96.7623 231.323 96.5881 231.172 96.4123C230.924 96.1251 230.637 95.8824 230.353 95.6376C230.208 95.5137 230.062 95.3926 229.921 95.2658C229.841 95.1943 229.772 95.1095 229.693 95.0377C229.422 94.7931 229.191 94.5084 228.952 94.2326C228.839 94.1014 228.744 93.9519 228.64 93.8115C228.424 93.5202 228.244 93.2056 228.072 92.8845C227.874 92.5172 227.735 92.1277 227.597 91.7347C227.423 91.2385 227.337 90.725 227.286 90.2037C227.241 89.7359 227.244 89.2671 227.285 88.7989C227.327 88.3104 227.392 87.8247 227.52 87.3521C227.606 87.0362 227.706 86.7232 227.82 86.4173C228.066 85.7586 228.415 85.1602 228.852 84.6194C229.047 84.3773 229.253 84.1423 229.472 83.9229C229.643 83.7507 229.845 83.6119 230.028 83.4511C230.328 83.187 230.674 82.9975 231.014 82.8007C231.378 82.5905 231.77 82.4492 232.166 82.3171C232.91 82.0686 233.674 81.9779 234.452 82.0044C234.945 82.0212 235.434 82.0885 235.91 82.2237C236.329 82.3427 236.741 82.4893 237.131 82.6942C237.659 82.9719 238.147 83.3109 238.587 83.7254C238.786 83.9132 238.966 84.1186 239.143 84.3279C239.447 84.6882 239.699 85.0856 239.915 85.5078C239.996 85.668 240.066 85.8352 240.136 86.0015C240.607 87.1235 240.722 88.292 240.558 89.4972C240.5 89.9169 240.411 90.3294 240.259 90.722C240.143 91.0225 239.998 91.3116 239.855 91.5995C239.704 91.9004 239.502 92.1667 239.298 92.4295C239.182 92.5801 239.042 92.7121 238.912 92.8507C238.602 93.1779 238.251 93.4508 237.873 93.6835C237.671 93.8078 237.452 93.9037 237.243 94.015C236.829 94.2344 236.384 94.3496 235.93 94.4306C235.271 94.5487 234.611 94.539 233.952 94.4134C233.583 94.343 233.222 94.2387 232.879 94.0827C232.667 93.9867 232.465 93.8686 232.263 93.7504C231.914 93.5458 231.602 93.2858 231.32 92.994C231.03 92.6932 230.776 92.3589 230.56 91.9926C230.305 91.5601 230.128 91.0977 229.999 90.6105C229.794 89.8408 229.784 89.0657 229.942 88.2906C230.034 87.8358 230.181 87.395 230.408 86.99C230.661 86.5386 230.967 86.1305 231.349 85.7865C231.648 85.5166 231.978 85.2952 232.335 85.1155C233.306 84.6264 234.314 84.5476 235.351 84.8332C235.578 84.8957 235.793 84.9951 236.005 85.1055C236.505 85.3662 236.916 85.7353 237.277 86.1722C237.316 86.22 237.347 86.2754 237.382 86.327C237.871 87.0444 238.107 87.8407 238.064 88.721C238.046 89.1078 237.971 89.4836 237.82 89.8389C237.704 90.1136 237.56 90.3733 237.38 90.6107C237.14 90.9289 236.857 91.1987 236.527 91.4133C236.28 91.5734 236.012 91.6807 235.732 91.761C235.37 91.8649 235.003 91.9031 234.634 91.8393C234.222 91.7683 233.831 91.6337 233.478 91.3903C233.231 91.2195 233.021 91.0071 232.848 90.7626C232.619 90.4385 232.482 90.0683 232.424 89.6689C232.407 89.5565 232.38 89.4423 232.386 89.3306C232.411 88.8583 232.526 88.4144 232.815 88.035C233.081 87.6848 233.427 87.4643 233.842 87.3497C234.026 87.299 234.208 87.2638 234.395 87.3022C234.75 87.3756 235.064 87.5279 235.295 87.8353C235.461 88.0571 235.556 88.3033 235.544 88.5843C235.534 88.8352 235.446 89.0519 235.24 89.2029C235.119 89.2918 234.986 89.3335 234.837 89.3154C234.686 89.2969 234.603 89.2038 234.604 89.0448C234.604 88.982 234.619 88.9194 234.627 88.8566C234.651 88.6605 234.568 88.5514 234.378 88.5281C234.033 88.4859 233.713 88.712 233.641 89.0641C233.567 89.4231 233.656 89.7411 233.869 90.0377C234.218 90.5247 234.878 90.7073 235.501 90.4846C235.778 90.3857 236.022 90.2371 236.231 90.0185C236.727 89.5002 236.914 88.8805 236.8 88.1673C236.742 87.8027 236.616 87.457 236.413 87.1499C236.167 86.7786 235.85 86.4896 235.466 86.2754C234.828 85.9193 234.16 85.8746 233.467 86.0477C233.167 86.1226 232.896 86.2646 232.632 86.4243C232.286 86.6333 232.002 86.9149 231.758 87.2399C231.668 87.3591 231.593 87.4913 231.521 87.6228C230.998 88.566 230.96 89.5521 231.292 90.5659C231.42 90.956 231.615 91.3122 231.857 91.6379C232.038 91.8818 232.244 92.1008 232.474 92.2994C232.763 92.5479 233.081 92.7346 233.42 92.8933C234.327 93.3182 235.253 93.3274 236.194 93.0396C236.511 92.9426 236.807 92.7936 237.096 92.6311C237.438 92.4391 237.746 92.1961 238.02 91.9128C238.248 91.6784 238.454 91.4249 238.634 91.1456C238.867 90.7836 239.032 90.3936 239.169 89.9853C239.452 89.1425 239.467 88.2876 239.273 87.4282C239.202 87.114 239.083 86.8106 238.976 86.5062C238.856 86.1627 238.667 85.8546 238.468 85.557C238.248 85.2279 237.992 84.9299 237.703 84.6591C237.423 84.3964 237.115 84.1827 236.794 83.9811C236.396 83.7311 235.964 83.5786 235.519 83.4567C234.848 83.2734 234.168 83.2618 233.484 83.3415C232.853 83.415 232.244 83.5825 231.678 83.8845C231.387 84.0401 231.105 84.2232 230.844 84.4277C230.579 84.6347 230.332 84.8679 230.112 85.1312C229.906 85.3775 229.721 85.6375 229.54 85.9029C229.344 86.1903 229.194 86.5026 229.044 86.816C228.778 87.3697 228.632 87.9579 228.534 88.5654C228.46 89.0206 228.447 89.4755 228.506 89.9273C228.599 90.6405 228.766 91.336 229.08 91.9848C229.191 92.2148 229.296 92.4497 229.423 92.67C229.793 93.3112 230.241 93.8867 230.799 94.3651C231.145 94.6619 231.522 94.9075 231.919 95.1251C232.416 95.3973 232.946 95.5642 233.487 95.7039C234.08 95.8568 234.68 95.9193 235.289 95.8944C235.774 95.8747 236.25 95.7907 236.719 95.6594C237.168 95.5339 237.604 95.3738 238.033 95.1918C238.495 94.9958 238.975 94.8749 239.464 94.7857C240.109 94.668 240.758 94.6475 241.409 94.7111C241.856 94.7547 242.295 94.8416 242.726 94.969C243.267 95.1289 243.786 95.3501 244.28 95.6263C244.57 95.7878 244.851 95.9693 245.115 96.1714C245.402 96.391 245.685 96.6205 245.926 96.8985C246.059 97.0521 246.209 97.1899 246.334 97.3501C246.512 97.5795 246.676 97.8214 246.842 98.0607C247.085 98.4116 247.264 98.7989 247.434 99.1923C247.686 99.775 247.838 100.385 247.93 101.013C247.956 101.191 247.977 101.37 248 101.548V102.613C247.994 102.645 247.986 102.677 247.982 102.709C247.964 102.855 247.951 103.002 247.93 103.147C247.835 103.784 247.679 104.402 247.42 104.99C247.265 105.34 247.1 105.681 246.887 105.998C246.717 106.25 246.539 106.495 246.345 106.729C246.1 107.025 245.819 107.281 245.533 107.529C245.256 107.771 244.946 107.967 244.632 108.154C244.297 108.355 243.937 108.503 243.575 108.641C243.151 108.804 242.708 108.896 242.258 108.95C242.129 108.965 242.001 108.983 241.873 109H241.165C241.113 108.992 241.061 108.981 241.009 108.975C240.884 108.96 240.758 108.952 240.633 108.932C240.178 108.861 239.729 108.767 239.306 108.569C239.047 108.448 238.78 108.342 238.531 108.201C238.124 107.97 237.742 107.697 237.407 107.36C237.29 107.243 237.168 107.131 237.055 107.01C236.973 106.922 236.907 106.819 236.825 106.731C236.587 106.472 236.419 106.161 236.239 105.862C236.038 105.528 235.899 105.16 235.777 104.789C235.609 104.279 235.518 103.751 235.5 103.211C235.471 102.388 235.573 101.586 235.881 100.819C236.007 100.503 236.139 100.192 236.326 99.9071C236.495 99.6487 236.666 99.3948 236.865 99.1576C237.096 98.8813 237.356 98.6387 237.634 98.4224C237.89 98.2237 238.171 98.0564 238.453 97.8984C238.79 97.7092 239.157 97.5909 239.53 97.5017C239.932 97.4058 240.336 97.3452 240.75 97.3631C241.002 97.374 241.252 97.3935 241.501 97.437C242.063 97.535 242.602 97.6918 243.102 97.9836C243.532 98.2344 243.907 98.5534 244.237 98.931C244.332 99.0401 244.411 99.1641 244.501 99.2783C244.749 99.5909 244.923 99.9495 245.093 100.309C245.25 100.64 245.34 100.996 245.394 101.361C245.546 102.39 245.389 103.361 244.885 104.266C244.628 104.728 244.303 105.131 243.896 105.456C243.697 105.614 243.484 105.757 243.265 105.886C243.021 106.03 242.755 106.126 242.482 106.199C241.676 106.413 240.884 106.367 240.114 106.04C239.593 105.818 239.161 105.47 238.796 105.022C238.521 104.684 238.323 104.301 238.197 103.887C237.976 103.158 237.999 102.434 238.299 101.724C238.466 101.33 238.701 100.99 239.004 100.703C239.264 100.455 239.57 100.276 239.901 100.15C240.29 100.002 240.693 99.9702 241.102 100.046C241.788 100.173 242.315 100.544 242.658 101.173C242.886 101.592 242.944 102.051 242.834 102.522C242.726 102.985 242.467 103.33 242.062 103.562C241.7 103.769 241.08 103.797 240.706 103.329C240.57 103.158 240.533 102.971 240.561 102.761C240.577 102.643 240.63 102.549 240.725 102.476C240.849 102.381 240.936 102.382 241.051 102.486C241.106 102.535 241.166 102.58 241.228 102.619C241.291 102.659 241.364 102.664 241.423 102.613C241.594 102.463 241.717 102.287 241.69 102.036C241.67 101.85 241.581 101.701 241.455 101.576C241.279 101.399 241.061 101.313 240.819 101.29C240.607 101.27 240.409 101.324 240.213 101.405C239.979 101.502 239.789 101.66 239.638 101.861C239.433 102.133 239.326 102.451 239.31 102.799C239.264 103.782 239.84 104.565 240.636 104.867C241.638 105.248 242.541 105.005 243.325 104.273C243.567 104.047 243.755 103.77 243.895 103.459C244.095 103.012 244.21 102.549 244.193 102.052C244.181 101.707 244.126 101.373 244.007 101.051C243.953 100.905 243.904 100.757 243.839 100.617C243.612 100.13 243.288 99.7214 242.872 99.3977C242.697 99.2617 242.511 99.136 242.316 99.033C241.861 98.7923 241.372 98.669 240.861 98.6553C240.121 98.6354 239.429 98.8112 238.783 99.1951C238.363 99.4441 238.008 99.7662 237.696 100.142C237.495 100.385 237.334 100.661 237.191 100.945C237.018 101.288 236.911 101.654 236.831 102.032C236.74 102.465 236.708 102.902 236.76 103.341C236.837 103.99 236.999 104.611 237.314 105.189C237.559 105.639 237.86 106.039 238.217 106.392C238.484 106.657 238.791 106.876 239.114 107.066C239.454 107.267 239.822 107.406 240.195 107.524C240.577 107.645 240.974 107.695 241.374 107.7C241.91 107.708 242.435 107.643 242.948 107.473C243.419 107.317 243.871 107.124 244.289 106.847C244.585 106.651 244.86 106.429 245.112 106.177C245.244 106.046 245.357 105.895 245.485 105.759C245.718 105.513 245.889 105.219 246.055 104.926C246.308 104.481 246.492 104.001 246.604 103.496C246.848 102.403 246.81 101.318 246.475 100.248C246.348 99.8455 246.187 99.4613 245.975 99.0976C245.757 98.7239 245.511 98.3753 245.235 98.0462C245.035 97.8062 244.805 97.5976 244.575 97.3924C244.29 97.1394 243.969 96.9369 243.642 96.7479C243.293 96.546 242.919 96.4017 242.541 96.271C242.088 96.1141 241.617 96.033 241.141 96.0056C240.31 95.958 239.495 96.038 238.701 96.3252C238.137 96.5294 237.604 96.7916 237.109 97.1375C236.689 97.4307 236.313 97.7765 235.961 98.1537C235.708 98.425 235.486 98.722 235.285 99.0323C235.089 99.3358 234.924 99.6636 234.767 99.9915C234.601 100.336 234.497 100.705 234.396 101.076C234.324 101.341 234.268 101.607 234.237 101.88C234.161 102.544 234.04 103.197 233.811 103.825C233.667 104.22 233.515 104.609 233.316 104.979C233.12 105.341 232.906 105.688 232.66 106.014C232.424 106.326 232.161 106.612 231.885 106.889C231.641 107.134 231.374 107.347 231.101 107.55C230.814 107.763 230.504 107.943 230.193 108.117C229.763 108.359 229.298 108.519 228.832 108.668C228.494 108.777 228.144 108.838 227.793 108.883C227.197 108.96 226.6 108.962 226.004 108.882C225.56 108.822 225.126 108.724 224.699 108.575C224.137 108.378 223.602 108.128 223.104 107.796C222.699 107.527 222.329 107.212 221.985 106.862C221.691 106.563 221.427 106.236 221.194 105.886C221.008 105.605 220.847 105.306 220.693 105.004C220.481 104.588 220.344 104.14 220.222 103.689C220.125 103.327 220.072 102.954 220.042 102.579C220.038 102.522 220.015 102.466 220 102.41C220 102.131 220 101.852 220 101.573L220 101.574ZM233.146 96.8281C233.083 96.8248 233.048 96.8711 233.068 96.9288C233.078 96.96 233.1 96.9873 233.116 97.0164C233.226 97.2131 233.346 97.4048 233.444 97.6075C233.62 97.9713 233.745 98.3545 233.8 98.7599C233.807 98.8103 233.798 98.8794 233.869 98.8927C233.948 98.9074 233.961 98.8341 233.983 98.7842C234.142 98.4237 234.359 98.1028 234.615 97.8122C234.781 97.6227 234.972 97.4561 235.152 97.2795C235.172 97.2592 235.198 97.2438 235.216 97.2213C235.25 97.1778 235.236 97.1288 235.185 97.1124C235.162 97.1052 235.136 97.1058 235.112 97.1045C234.844 97.0911 234.575 97.0865 234.308 97.0627C233.927 97.0287 233.549 96.9745 233.185 96.8407C233.17 96.8351 233.154 96.8308 233.146 96.8281Z"
          fill="black"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_2_4"
        x={-50}
        y={34.83}
        width={300.1}
        height={509.57}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={25} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2_4"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2_4"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_2_4"
        x={764.89}
        y={35.93}
        width={235.11}
        height={509.94}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={5} />
        <feGaussianBlur stdDeviation={25} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2_4"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2_4"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_2_4"
        x={629.47}
        y={35.93}
        width={235.41}
        height={509.94}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={5} />
        <feGaussianBlur stdDeviation={25} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2_4"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2_4"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_2_4"
        x={493.76}
        y={35.93}
        width={235.72}
        height={509.94}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={5} />
        <feGaussianBlur stdDeviation={25} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2_4"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2_4"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d_2_4"
        x={404.64}
        y={80.93}
        width={143.11}
        height={417.94}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2_4"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2_4"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_d_2_4"
        x={363.64}
        y={30.93}
        width={235.11}
        height={509.94}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx={5} />
        <feGaussianBlur stdDeviation={25} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2_4"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2_4"
          result="shape"
        />
      </filter>
      <pattern
        id="pattern0_2_4"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use xlinkHref="#image0_2_4" transform="scale(0.00326797 0.00175439)" />
      </pattern>
      <image
        id="image0_2_4"
        width={306}
        height={570}
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);

function Home({ isCampaign }) {
  const appStoreLink = isCampaign
    ? "https://apps.apple.com/in/app/triskel-wallet/id6449494626?utm_source=twitter&utm_medium=paid-social&utm_campaign=eu_consideration1&utm_content=cryptocard "
    : "https://apps.apple.com/in/app/triskel-wallet/id6449494626?utm_source=website&utm_medium=organic&utm_campaign=homepage&utm_content=cta";

  const playStoreLink = isCampaign
    ? "https://play.google.com/store/apps/details?id=com.triskel&utm_source=twitter&utm_medium=paid-social&utm_campaign=eu_consideration1&utm_content=cryptocard"
    : "https://play.google.com/store/apps/details?id=com.triskel&utm_source=website&utm_medium=organic&utm_campaign=homepage&utm_content=cta";

  return (
    <div className="home">
      <SuperApp appStoreLink={appStoreLink} playStoreLink={playStoreLink} />
      {/* <Banner /> */}
      {!isCampaign && <OurPartner />}
      {!isCampaign && <KeyFeature />}
      {/* <OurCertificate appStoreLink={appStoreLink} playStoreLink={playStoreLink}/> */}
      {/* <Explore /> */}

      <div className="container" style={{ background: "#101010" }}>
        <div className="cryptoCard" id="cryptoCard">
          <div className="cryptoCard_left">
            <video src="/card.mp4" autoPlay playsInline muted loop />
          </div>
          <div className="cryptoCard_right">
            <h2>Crypto Card</h2>
            <p>
              <b> USDC - backed Visa card.</b> We work where Visa works. Use
              your Credit powered hybrid crypto card to make purchases wherever
              Visa is accepted.
            </p>
            <ul>
              <li>
                <CheckOutlined />
                Low Fees: Minimal charges for maximum convenience.
              </li>

              <li>
                <CheckOutlined />
                Available in 170+ countries
              </li>

              <li>
                <CheckOutlined />
                No spending limits
              </li>

              <li>
                <CheckOutlined />
                Decentralized structure for enhanced security and compliance
              </li>
            </ul>
            <div className="bannerbuttons">
              <Link target="_blank" to={playStoreLink}>
                <GreenPlay />
              </Link>
              <Link target="_blank" to={appStoreLink}>
                <GreenApp />
              </Link>
            </div>
          </div>
        </div>
        {/* <table className="cryptoCardTable">
          <thead>
            <tr>
              <th>Features</th>
              <th>Triskel Wallet</th>
              <th>MetaMask</th>
              <th>Trust Wallet</th>
              <th>SORA Card</th>
              <th>Yomi Wallet</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Wallet Services</td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
            </tr>
            <tr>
              <td>Crypto Debit Card</td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CloseOutlined />
              </td>
              <td>
                <CloseOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
            </tr>
            <tr>
              <td>IBAN Facility</td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CloseOutlined />
              </td>
              <td>
                <CloseOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
            </tr>
            <tr>
              <td>STO Platform</td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CloseOutlined />
              </td>
              <td>
                <CloseOutlined />
              </td>
              <td>
                <CloseOutlined />
              </td>
              <td>
                <CloseOutlined />
              </td>
            </tr>
            <tr>
              <td>Cross-Chain Swaps</td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CloseOutlined />
              </td>
              <td>
                <CloseOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
            </tr>
            <tr>
              <td>On/Off-Ramp Integration</td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CloseOutlined />
              </td>
              <td>
                <CloseOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
            </tr>
            <tr>
              <td>Multi-Language Support</td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
            </tr>
            <tr>
              <td>Regulatory Compliance</td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
              <td>
                <CheckOutlined />
              </td>
            </tr>
          </tbody>
        </table>

        <div className="tableRow">
          <Table />
        </div> */}
      </div>

      <Transactions appStoreLink={appStoreLink} playStoreLink={playStoreLink} />

      <UseCases />
      {!isCampaign && <Token />}
      <WhyTriskel />
      {!isCampaign && <DeepDive />}
      
      {/* <Balancing /> */}
      {!isCampaign && <Roadmap />}
      {isCampaign && <OurPartner />}
      <FrequentlyAsked />
      <DownloadSuperApp appStoreLink={appStoreLink} playStoreLink={playStoreLink} />
    </div>
  );
}

export default Home;
